import { DateTime } from "luxon";

// True from the morning of the booking's check-out date, judged by the
// property's clock — never the phone's.
//
// Two timezone traps are handled deliberately:
// - "Today" is computed with Luxon in the property's zone
//   (`room.owner.timezone`, same source the door lock uses). A guest whose
//   phone is still on home time flips over exactly when the property does.
// - `checkOutDate` is treated as a calendar date: the part before any "T" is
//   the date the host meant. Parsing it through `new Date()` would read it
//   as UTC midnight and show check-out a day early in every zone west of
//   Greenwich (see the same dodge in LookupDrawer's formatDateForDisplay).
export const isCheckOutDay = (booking, room) => {
  if (!booking?.checkOutDate) return false;

  try {
    const zone = room?.owner?.timezone || "America/Los_Angeles";
    const today = DateTime.now().setZone(zone);
    if (!today.isValid) return false;

    const checkOutDate = String(booking.checkOutDate).split("T")[0];
    if (!/^\d{4}-\d{2}-\d{2}$/.test(checkOutDate)) return false;

    // ISO date strings compare correctly as plain strings. ">=" so the swap
    // also holds if someone opens a still-active link just past check-out.
    return today.toISODate() >= checkOutDate;
  } catch (error) {
    return false;
  }
};
